import { useMutation, useQueryClient } from "@tanstack/react-query";

import { CRM_LISTS_QUERY_KEY } from "app/pages/sales-intelligence/modules/lists/sub-modules/crm-list/services/queries/queryKeyFactory";
import type {
    DigestSubscription,
    UpdateDigestSubscriptionDTO,
} from "app/pages/sales-intelligence/sub-modules/signals-alerts/models/DigestSubscription";
import signalsAlertsAPIService from "app/pages/sales-intelligence/sub-modules/signals-alerts/services/api/signalsAlertsAPIService";

export default function useCRMSignalsAlertsFrequencyMutation() {
    const queryClient = useQueryClient();

    return useMutation<DigestSubscription, unknown, UpdateDigestSubscriptionDTO>({
        mutationFn(dto) {
            return signalsAlertsAPIService.updateDigestSubscription(dto);
        },
        onSuccess() {
            queryClient.invalidateQueries({ queryKey: [CRM_LISTS_QUERY_KEY] });
        },
    });
}
